import styled, { css } from 'styled-components'

import { minmedia } from '../../styles/media-queries'
import { white, bordergray, lightergray, red, black, inputgray } from '../../styles/colors'

export const AppointmentContainer = styled.div`
  transition: all 0.5s;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: ${props => (props.empty ? 'none' : `1px solid ${bordergray}`)};
  background: ${white};
  ${minmedia.medium`
    padding: 1.5rem;
  `}
  ${minmedia.large`
    padding: 2rem;
  `}

  ${props => props.dashboard && css`

    ${minmedia.medium`
      padding: 1rem 1.5rem;
      min-height: 75px;
    `}
    ${minmedia.large`
      padding: 1rem 2rem;
    `}
    ${minmedia.xmlarge`
      min-height: 85px;
    `}

    &:hover {
      background: ${props => (props.empty ? white : lightergray)};
    }
  `}
`

export const Content = styled.div`
  transition: all 0.5s;
  position: relative
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 110px);

  font-size: 18px;
  text-decoration: none;
  color: ${black};
  line-height: 1.2;

  ${minmedia.medium`
    font-size: 18px;
    width: calc(100% - 160px);
  `}
  ${minmedia.large`
    font-size: 20px;
  `}

  span {
    display: block;
    font-size: 14px;
    font-weight: 300;
    color: ${inputgray};
    width: 100%;
    margin-top: .25rem;

    ${minmedia.medium`
      font-size: 18px;
    `}
  }

  ${props => props.dashboard && css`

    ${minmedia.medium`
      font-size: 18px;
      width: calc(100% - 110px);
    `}
    ${minmedia.xmlarge`
      font-size: 22px;
      width: calc(100% - 160px);
    `}

    span {
      ${minmedia.medium`
        font-size: 14px;
      `}
      ${minmedia.xmlarge`
        font-size: 18px;
      `}
    }
  `}
`

export const DateContainer = styled.div`
  position: relative;
  width: 100px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;

  font-weight: 500;
  padding-left: 1rem;
  font-size: 14px;
  color: ${black};

  ${minmedia.medium`
    font-size: 18px;
    width: 150px;
  `}

  div {
    &:first-child {
      margin-bottom: 0.5rem;
    }
  }

  &::before {
    height: 100%;
    width: 3px;
    background: ${red};
    display: inline-block;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
  }

  ${props => props.dashboard && css`
    text-transform: uppercase;

    ${minmedia.medium`
      font-size: 14px;
      width: 100px;
    `}
    ${minmedia.xmlarge`
      font-size: 18px;
      width: 150px;
      padding-left: 1.25rem;
    `}
  `}
`



// WEBPACK FOOTER //
// ./src/components/Appointment/styles.js